import type { IconProps } from "./Icons";

export const IconCheckCircle = ({
  width = 32,
  height = 32,
  color = "#0B3E5F",
}: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="16"
      cy="16"
      r="12.8"
      stroke={color}
      strokeWidth="2"
    />
    <path
      d="M10.4 16.4L14.2 20.2L22.4 12.8"
      stroke={color}
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
